<template>
  <div>
    <v-data-table
      v-model="selected"
      :headers="headers"
      :items="items"
      :options.sync="options"
      :server-items-length="totalElements"
      :loading="isSearching"
      item-key="id"
      locale="pt-BR"
      show-select
      class="elevation-3 mt-2"
    >

      <template v-slot:item.copay="{item}">
        <v-row justify="center" class="mt-1 mb-1">
          <v-col cols="12">
            <v-select :items="coparticipationValues" return-object item-value="id" item-text="description" v-model="item.copayType"
                      label="Tipo de Coparticipação" outlined dense hide-details="true" style="width: 200px" @change="updateShareModelCarrierCopay(item)"
            ></v-select>
          </v-col>
        </v-row>
      </template>
      <template v-slot:item.description="{item}">
        <share-model-descriptions
          :item="item"
          :share-model-descriptions="getShareModelDescriptions"
          @on-description-created="updateShareModelCarrier"
          class="mt-1 mb-1"
        >
        </share-model-descriptions>
      </template>
    </v-data-table>
    <DlgConfirmCancel ref="confirm"></DlgConfirmCancel>
  </div>
</template>

<script>
import ShareModelCarrierService from '@/services/insurancepricing/ShareModelCarrierService';
import ShareModelDescriptions from '@/view/share_model/share_model_descriptions';
import {mapActions, mapGetters, mapMutations} from 'vuex';
import DlgConfirmCancel from '@/components/dlg-confirm_cancel.vue';

export default {
  components: {ShareModelDescriptions, DlgConfirmCancel},
  props: {
    shareModelId: {
      type: String,
    },
  },
  data() {
    return {
      headers: [
        {text: 'CNPJ', value: 'carrier.cnpj', width: '20%'},
        {text: 'Nome Fantasia', value: 'carrier.comercialName', width: '20%'},
        {text: 'Razão Social', value: 'carrier.razaoSocial', width: '20%'},
        {text: 'Tipo de Coparticipação', value: 'copay', width: '20%'},
        {text: 'Descrição', value: 'description', width: '20%'},
      ],
      coparticipationValues: ["10% de Coparticipação","20% de Coparticipação","30% de Coparticipação","40% de Coparticipação","50% de Coparticipação", "Sem Coparticipação", "Fixo"],
      isSearching: false,
      options: {},
      items: [],
      totalElements: null,
      singleSelect: false,
      selected: [],
    };
  },
  async created() {
    this._service = new ShareModelCarrierService();
  },
  watch: {
    options: {
      handler() {
        this.loadData();
      },
      deep: true,
    },
  },
  computed: {
    ...mapGetters('shareModel', ['getShareModelDescriptions']),
  },
  methods: {
    ...mapActions('shareModel', ['fetchShareModelDescriptions']),
    ...mapMutations(['toogleDialogLoading', 'showmsg']),
    async updateShareModelCarrier(shareModelCarrier, shareModelDescriptionId) {
      const bodyFormData = new FormData();
      bodyFormData.append('shareModelDescriptionId', shareModelDescriptionId);
      await this._service.update(
        this.shareModelId,
        shareModelCarrier.id,
        bodyFormData,
      );
    },
    async updateShareModelCarrierCopay(shareModelCarrier) {
      const bodyFormData = new FormData();
      bodyFormData.append('copayType', shareModelCarrier.copayType);
      await this._service.updateCopay(
        this.shareModelId,
        shareModelCarrier.id,
        bodyFormData,
      );
    },
    async loadData() {
      this.isSearching = true;
      const {sortBy, sortDesc, page, itemsPerPage} = this.options;
      this._service
        .findAllByShareModelId(this.shareModelId, {
          page: page ? page - 1 : 0,
          sortBy:
            sortBy && sortBy.length
              ? sortBy[0] === 'account.carrierName'
                ? 'carrier.name'
                : sortBy[0]
              : 'carrier.razaoSocial',
          descending: sortDesc && sortDesc.length ? sortDesc[0] : false,
          size: itemsPerPage,
        })
        .then((res) => {
          this.items = res.data.content;
          this.totalElements = res.data.totalElements;
          this.isSearching = false;
          this.$emit('on-load');
        });

      if (!this.getShareModelDescriptions.length) {
        this.fetchShareModelDescriptions(this.shareModelId);
      }
    },
    async removeAll() {
      if (
        this.selected.length &&
        (await this.$refs.confirm.show(
          'Atenção',
          'Deseja excluir os registros selecionados?',
        ))
      ) {
        this.toogleDialogLoading(true);
        for (const shareModelPlan of this.selected) {
          await this._service.delete(this.shareModelId, shareModelPlan.id);
        }
        this.showmsg({text: 'Operadoras desassociadas com sucesso!'});
        this.toogleDialogLoading(false);
        await this.loadData();
      }
    },
  },
};
</script>
